// extracted by css-extract-rspack-plugin
export default {"holo":"FilterGroup_holo_v4Ryy"};